import { Injectable } from '@angular/core';

import { TimerService } from '@frontend/sports/common/core/utils/timer';

@Injectable({
    providedIn: 'root',
})
export class WinPickDelayService {
    picks: string[] = [];
    constructor(private timer: TimerService) {}

    addPick(el: string): void {
        this.picks.push(el);
        this.timer.setTimeout(() => {
            this.removePick(el);
        }, 500);
    }

    isPickExist(pick: string): boolean {
        return !!this.picks?.find((pickId) => pick === pickId);
    }

    removePick(item: string): void {
        this.picks = this.picks.filter((pickId) => item !== pickId);
    }
}
